import { swSettings } from "app/common/services/swSettings";
import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import { ACTIVATION_ROOT_ROUTE } from "app/pages/activation/routing/constants";
import {
    BENCHMARK_TRACKER_REPORT_ROUTE,
    BENCHMARK_TRACKER_REPORT_URL,
    CONFIG_ID,
    DEFAULT_TAB,
    SECONDARY_BAR_TYPE,
    benchmarkResolver,
    isBenchmarkTrackerAllowed,
    onRedirectToReport,
} from "app/pages/benchmark-tracker";
import { BenchmarkReport } from "app/pages/benchmark-tracker/report";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";

export const reportConfig = {
    [BENCHMARK_TRACKER_REPORT_ROUTE]: {
        parent: ACTIVATION_ROOT_ROUTE,
        url: `${BENCHMARK_TRACKER_REPORT_URL}/:key/:country/:duration/:granularity/:webSource?tab&downloadPdf&pdf&isDurationChanged`,
        params: {
            tab: {
                dynamic: true,
                get value() {
                    return swSettings.components?.BenchmarkTracker?.defaultParams.tab ?? DEFAULT_TAB;
                },
            },
            downloadPdf: {
                dynamic: true,
                value: "0",
            },
            isDurationChanged: {
                type: "bool",
                dynamic: true,
                inherit: false,
            },
        },
        component: BenchmarkReport,
        configId: CONFIG_ID,
        configIdDeps: ["WebAnalysis", "MobileWeb", "MobileWebWorldwide"],
        trackingId: {
            section: "benchmark",
            subSection: "benchmark page",
            subSubSection: "report",
        },
        pageId: {
            section: "benchmark",
            subSection: "benchmark page",
            subSubSection: "report",
        },
        pageTitle: "bt.home.page.title",
        isSecondaryBarOpen: false,
        secondaryBarType: SECONDARY_BAR_TYPE,
        redirectTo: redirectPipe(isBenchmarkTrackerAllowed, onRedirectToReport()),
        secondaryBarType3: SecondarySideBarType3.BenchmarkTracker,
        hideSecondaryBar3: true,
        hideFromRecents: true,
        resolve: [benchmarkResolver],
    },
};
